<template>
  <el-form ref="form"
           :model="form"
           label-position="left"
           :rules="rules"
           style="padding:20px;background:#fff"
           label-width="180px">
    <p>基本信息</p>
    <el-row :gutter="50">
      <el-col :span="8">
        <el-form-item label="企业全称："
                      prop="client.customerfullname">
          <el-input v-model="form.client.customerfullname"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="客户状态："
                      prop="client.customerStatus">
          <el-select v-model="form.client.customerStatus"
                     placeholder="请选择">
            <el-option label="已绑定"
                       :value="1"></el-option>
            <el-option label="未绑定"
                       :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="代理商联系方式：">
          <el-input v-model="form.client.agentPhoneNumber"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="企业简称："
                      prop="client.customername">
          <el-input v-model="form.client.customername"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户状态备注：">
          <el-input v-model="form.client.customerStatusRemark"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户负责人1："
                      prop="managerList[0].customerPrinciple">
          <el-input v-model="form.managerList[0].customerPrinciple"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户所属集团：">
          <el-input v-model="form.client.customergroup"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户整体评价："
                      prop="client.customerScores">
          <el-select v-model="form.client.customerScores"
                     placeholder="请选择">
            <el-option label="优"
                       :value="1"></el-option>
            <el-option label="良"
                       :value="2"></el-option>
            <el-option label="差"
                       :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户负责人1联系电话："
                      prop="managerList[0].customerPrincipleNumber">
          <el-input v-model="form.managerList[0].customerPrincipleNumber"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户回签率：">
          <el-input v-model="form.client.backSignatureRate"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户评价描述：">
          <el-input v-model="form.client.customerScoresDetail"
                    type="textarea"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户负责人2：">
          <el-input v-model="form.managerList[1].customerPrinciple"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="客户负责人2联系电话：">
          <el-input v-model="form.managerList[1].customerPrincipleNumber"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="客户信用："
                      prop="client.customerCredit">
          <el-select v-model="form.client.customerCredit"
                     placeholder="请选择">
            <el-option label="优"
                       :value="1"></el-option>
            <el-option label="良"
                       :value="2"></el-option>
            <el-option label="差"
                       :value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户信用描述：">
          <el-input v-model="form.client.customerCreditDeatail"
                    type="textarea"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="客户方负责人3：">
          <el-input v-model="form.managerList[2].customerPrinciple"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="客户方负责人3联系电话：">
          <el-input v-model="form.managerList[2].customerPrincipleNumber"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="销售负责人："
                      prop="client.salesmanname">
<!--
          <el-input v-model="form.client.salesmanname"></el-input>
-->
          <el-select v-model="form.client.salesmanname"
                     filterable
                     clearable
                     @change="changeSalesmanname"
                     placeholder="请选择销售负责人">
            <el-option v-for="item in userNames"
                       :key="item.userId"
                       :label="item.username"
                       :value="item.username">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="销售联系方式"
                      prop="client.salesmanPhoneNumber">
          <el-input v-model="form.client.salesmanPhoneNumber"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="客户需求反馈：">
          <el-input v-model="form.client.customerDemandFeedback"
                    type="textarea"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="代理负责人：">
<!--
          <el-input v-model="form.client.agentPrincipal"></el-input>
-->
          <el-select v-model="form.client.agentPrincipal"
                     filterable
                     clearable
                     @change="changeAgentPrincipal"
                     placeholder="请选择代理负责人">
            <el-option v-for="item in userNames"
                       :key="item.userId"
                       :label="item.username"
                       :value="item.username">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="ax_default line"></div>
    <p class="text">客户风险等级</p>
    <el-row :gutter="60">
      <el-col :span="8">
        <el-form-item label="客户重要等级："
                      prop="client.clientLevel">
          <el-select v-model="form.client.clientLevel"
                     placeholder="请选择">
            <el-option label="一般"
                       :value="1"></el-option>
            <el-option label="重要"
                       :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="客户电压等级："
                      prop="client.clientEleLevel">
          <el-select v-model="form.client.clientEleLevel"
                     placeholder="请选择电压等级">
            <el-option label="不满1kV"
                       :value="1"></el-option>
            <el-option label="1-10kV"
                       :value="2"></el-option>
            <el-option label="35kV"
                       :value="3"></el-option>
            <el-option label="11kV"
                       :value="4"></el-option>
            <el-option label="110kV"
                       :value="5"></el-option>
            <el-option label="220kV及以上"
                       :value="6"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <p>工商资料</p>
    <el-row :gutter="60">
      <el-col :span="8">
        <el-form-item label="法人代表："
                      prop="clientDetail.lar">
          <el-input v-model="form.clientDetail.lar"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="注册资本：">
          <el-input v-model="form.clientDetail.regisCapital"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="邮编：">
          <el-input v-model="form.clientDetail.postCode"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="法人身份证号："
                      prop="clientDetail.larIdcard">
          <el-input v-model="form.clientDetail.larIdcard"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="企业性质：">
          <el-select v-model="form.clientDetail.industry"
                     placeholder="请选择">
            <el-option label="私企"
                       :value="1"></el-option>
            <el-option label="国企"
                       :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="所属园区：">
          <el-input v-model="form.clientDetail.park"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="信用代码："
                      prop="clientDetail.creditCode">
          <el-input v-model="form.clientDetail.creditCode"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="公司性质：">
          <el-input v-model="form.clientDetail.companyNature"
                    placeholder=""></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8"
              style="margin:0">
        <el-col :span="10"
                style="padding:0">
          <el-form-item label="所在城市："
                        prop="client.provinceCode"
                        label-width="120px">
            <el-select v-model="form.client.provinceCode"
                       class="city"
                       @change='getCity'
                       placeholder="请选择省">
              <el-option v-for="item in provinceoptions"
                         :key="item.code"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="client.cityCode"
                        label-width="0">
            <el-select v-model="form.client.cityCode"
                       class="city"
                       @change='getTown'
                       style="margin:0 10px"
                       placeholder="请选择">
              <el-option v-for="item in cityoptions"
                         :key="item.code"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="client.townCode"
                        label-width="0">
            <el-select v-model="form.client.townCode"
                       class="city"
                       placeholder="请选择">
              <el-option v-for="item in townoptions"
                         :key="item.code"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-col>
      <el-col :span="8">
        <el-form-item label="成立日期："
                      prop="clientDetail.establishDate">
          <el-date-picker type="date"
                          placeholder="选择日期"
                          value-format="yyyy-MM-dd"
                          v-model="form.clientDetail.establishDate"></el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="经营范围：">
          <el-input v-model="form.clientDetail.businessNature"
                    type="textarea"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="详细地址：">
          <el-input v-model="form.clientDetail.detailAddress"
                    type="textarea"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="ax_default line"></div>
    <p class="text">交易信息</p>
    <el-row :gutter="60">
      <el-col :span="8">
        <el-form-item label="账户名称：">
          <el-input v-model="form.clientDetail.accountName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="开户银行：">
          <el-input v-model="form.clientDetail.accountBlank"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
      </el-col>
      <el-col :span="8">
        <el-form-item label="账户账号：">
          <el-input v-model="form.clientDetail.accountNumber"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="财务联系电话：">
          <el-input v-model="form.clientDetail.financePhone"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="ax_default line"></div>
    <el-form-item>
      <div style="text-align:center">
        <el-button @click="$router.back()">取消</el-button>
        <el-button @click="submitForm('form')"
                   type="primary">保存</el-button>
      </div>

    </el-form-item>
  </el-form>
</template>
<script>
import { getClientInfo, postClientInfo, putClientInfo, getprovince, getcity, gettown, getUserNames } from '../../API'
let id = 0;
export default {
  data () {
    return {
      form: {
        client: {
          agentPhoneNumber: '',
          agentPrincipal: '',
          agentid: 0,
          backSignatureRate: '',
          clientEleLevel: '',
          clientLevel: '',
          customerCredit: '',
          customerCreditDeatail: '',
          customerDemandFeedback: '',
          customerScores: '',
          customerScoresDetail: '',
          customerStatus: '',
          customerStatusRemark: '',
          customerfullname: '',
          customergroup: '',
          customerlevel: 0,
          customername: '',
          delFlag: 0,
          id: '',
          provinceCode: '',
          salesmanPhoneNumber: '',
          salesmanid: 0,
          salesmanname: '',
          traderid: 0,
        },
        clientDetail: {
          accountBlank: '',
          accountName: '',
          accountNumber: '',
          businessNature: '',
          city: 0,
          clientId: '',
          companyNature: '',
          creditCode: '',
          detailAddress: '',
          detailId: '',
          establishDate: '',
          financePhone: '',
          industry: '',
          lar: '',
          larIdcard: '',
          park: '',
          postCode: '',
          regisCapital: '',
        },
        managerList: [
          {
            clientId: '',
            customerId: 0,
            customerPrinciple: '',
            customerPrincipleNumber: '',
            delFlag: 0,
            principleId: '',
          },
          {
            clientId: '',
            customerId: '',
            customerPrinciple: '',
            customerPrincipleNumber: '',
            delFlag: '',
            principleId: '',
          },
          {
            clientId: '',
            customerId: '',
            customerPrinciple: '',
            customerPrincipleNumber: '',
            delFlag: '',
            principleId: '',
          }
        ]
      },
      rules: {
        client: {
          customerfullname: { required: true, message: '必填', trigger: 'blur' },
          customerStatus: { required: true, message: '必填', trigger: 'change' },
          customername: { required: true, message: '必填', trigger: 'blur' },
          salesmanname: { required: true, message: '必填', trigger: 'blur' },
          salesmanPhoneNumber: { required: true, message: '必填', trigger: 'blur' },
          clientLevel: { required: true, message: '必填', trigger: 'change' },
          clientEleLevel: { required: true, message: '必填', trigger: 'change' },
          townCode: { required: true, message: '必填', trigger: 'change' },
          cityCode: { required: true, message: '必填', trigger: 'change' },
          provinceCode: { required: true, message: '必填', trigger: 'change' },
        },
        clientDetail: {
          lar: { required: true, message: '必填', trigger: 'blur' },
          larIdcard: { required: true, message: '必填', trigger: 'blur' },
          creditCode: { required: true, message: '必填', trigger: 'blur' },
          salesmanname: { required: true, message: '必填', trigger: 'blur' },
          salesmanPhoneNumber: { required: true, message: '必填', trigger: 'blur' },
          clientLevel: { required: true, message: '必填', trigger: 'blur' },
          clientEleLevel: { required: true, message: '必填', trigger: 'blur' },
        },
        managerList: [
          {
            customerPrinciple: { required: true, message: '必填', trigger: 'blur' },
            customerPrincipleNumber: { required: true, message: '必填', trigger: 'blur' },
          },
        ],
        date1: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ],
        type: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '请填写活动形式', trigger: 'blur' }
        ]
      },
      provinceoptions: [],
      cityoptions: [],
      userNames: [],
      townoptions: []
    }
  },
  created () {
    if (localStorage.getItem('id')) {
      getClientInfo(localStorage.getItem('id')).then(res => {
        if (res.code === 0) {
          this.form = res.data
          this.form.clientDetail=this.form.clientDetail?this.form.clientDetail:{}
          getcity(res.data.client.provinceCode).then(res => {
            if (res.code === 0) {
              this.cityoptions = res.data
            }
          })
          gettown(res.data.client.cityCode).then(res => {
            if (res.code === 0) {
              this.townoptions = res.data
            }
          })
          for (let i = 0; i < 3; i++) {
            if (this.form.managerList[i]) {
              continue
            }
            else {
              this.form.managerList.push({
                clientId: localStorage.getItem('id'),
                customerId: null,
                customerPrinciple: null,
                customerPrincipleNumber: null,
                delFlag: null,
                principleId: null,
              })
            }
          }
        }
      })
    }
    getprovince().then(res => {
      if (res.code === 0) {
        this.provinceoptions = res.data
      }
    })
    getUserNames().then(res => {
        if (res.code === 0) {
            this.userNames = res.data
        }
    })
  },
  methods: {
    changeAgentPrincipal(data) {
        let resultArr = this.userNames.filter((item) =>{
            return item.username === data
        });
        // 判断数组是否为空
        if (typeof resultArr == "undefined" || resultArr == null || resultArr.length <= 0) {
            return;
        }
        this.form.client.agentid = resultArr[0].userId
    },
    changeSalesmanname(data) {
        let resultArr = this.userNames.filter((item) =>{
            return item.username === data0
        });
        // 判断数组是否为空
        if (typeof resultArr == "undefined" || resultArr == null || resultArr.length <= 0) {
            return;
        }
        this.form.client.salesmanid = resultArr[0].userId
    },
    getCity (code) {
      this.form.client.cityCode = ''
      this.form.client.townCode = ''
      this.townoptions = []
      this.cityoptions = []
      getcity(code).then(res => {
        if (res.code === 0) {
          this.cityoptions = res.data
        }
      })
    },
    getTown (code) {
      this.form.client.townCode = ''
      this.townoptions = []
      gettown(code).then(res => {
        if (res.code === 0) {
          this.townoptions = res.data
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('id')) {
            // this.form.clientDetail.clientId = localStorage.getItem('id')
            this.form.clientDetail.id = localStorage.getItem('id')
            this.form.client.provinceName = _.find(this.provinceoptions, { code: this.form.client.provinceCode.toString() }).name
            this.form.client.cityName = _.find(this.cityoptions, { code: this.form.client.cityCode.toString() }).name
            this.form.client.townName = _.find(this.townoptions, { code: this.form.client.townCode.toString() }).name
            putClientInfo(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })

          }
          else {
            let params = {
              client: this.form.client,
              clientDetail: this.form.clientDetail,
              managerList: this.form.managerList
            }
            postClientInfo(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            }).catch(err => {
              console.log(err)
            })
          }
        } else {
          return false;
        }
      });
    },
  },

}
</script>
<style lang='less' scoped>
.el-row {
  margin: 0 !important;
}
.text {
  font-weight: 650;
  font-style: normal;
  font-size: 14px;
  color: #666666;
  line-height: 21px;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid rgb(228, 228, 228);
  text-align: center;
  line-height: normal;
  margin-bottom: 10px;
}
.line {
  height: 1px;
}
/deep/ .el-input {
  width: 220px;
}
.city /deep/ .el-input {
  width: 100px;
}
</style>
